import {Trans, useTranslation} from 'gatsby-plugin-react-i18next';

const NutritionHydration = () => {
    const { t } = useTranslation();
    return (
        <>
            <section className="bg-dark multi-activity hero-bg position-relative section-pdn pt-8 nutri-hyd">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                    <div className="col-12 col-sm-8 col-md-8 col-lg-8">
                        <h1 className="font-weight-semibold hero-heading mt-5 no-br">
                            <Trans>Energize <br/>Your Employee's <br/>Workday</Trans>
                        </h1>
                        <p className="hero-para font-weight-semibold no-br">
                            <Trans>Empower your team to monitor and customize their <br/>nutrition and hydration for optimal daily performance.</Trans>
                        </p>
                        <div className="pl-0 col-12 col-md-7 mtb25 d-md-flex justify-content-between align-items-center">
                            <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                                <Trans>Book a Demo</Trans>
                            </a>
                        </div>
                    </div>
                </div>
            </section>


            <section className="position-relative pl-0 pr-0">
                <div className="">
                    <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
                        <div className="container custom_container d-flex m-d-block justify-content-center align-items-center home-bg-2 brd22 p-5 mb-5">
                            <div className="col-12 col-md-6">
                                <div className="col-12">
                                    <div className="features-label red-font">
                                    <Trans>Diet Journal</Trans>
                                    </div>
                                    <h2 className='font-weight-semibold py-2 section-heading'><Trans>Meal Tracking</Trans></h2>
                                    <p className='section-para font-weight-normal greenTick'><ul><li><Trans>Enable employees to easily log meals, helping them find their individual dietary balance.</Trans></li><li><Trans>Provide a vast array of food choices from our comprehensive database.</Trans></li><li><Trans>Integrate with Lose It and MyFitnessPal for simplified dietary tracking.</Trans></li></ul></p>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 cta-img p-0'>
                                <div className='d-flex justify-content-end px-0'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1706098778/VantageFit/2023/Nutrition-Hydration-Diet_tracker`)} fetchPriority="high" alt="Meal Tracking" width="621" height="815"/>
                                </div>
                            </div>
                        </div>
                        <div className="container custom_container d-flex flex-row-reverse m-d-block justify-content-center align-items-center home-bg-2 brd22 p-5">
                            <div className="col-12 col-md-6">
                                <div className="col-12">
                                    <div className="features-label green-font">
                                    <Trans>Stay Hydrated</Trans>
                                    </div>
                                    <h2 className='font-weight-semibold py-2 section-heading no-br'><Trans>Water Intake</Trans></h2>
                                    <p className='section-para font-weight-normal greenTick'><ul><li><Trans>Encourage employees to monitor their water consumption, ensuring they meet the recommended daily intake.</Trans></li><li><Trans>Implement a reminder system to prompt employees to hydrate regularly, fostering overall well-being.</Trans></li></ul></p>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 cta-img px-0'>
                                <div className='col-12 d-flex justify-content-start px-0'>
                                    <img className="img-responsive" src={t(`https://res.cloudinary.com/vantagecircle/image/upload/f_auto,q_auto/v1706098778/VantageFit/2023/Nutrition-Hydration-Stay_hydrated`)} loading='lazy' alt="Run Towards Goals" width="621" height="760"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="position-relative container">
                <div className="section-heading-top cursive">
                    <h2 className="section-heading font-weight-bold text-center mb-4 d-flex justify-content-center align-items-center m-d-block"><Trans i18nKey="subtextfeat2">Comprehensive&nbsp;<span className="charmonman green-clr">Wellness</span>&nbsp;Insights</Trans>&nbsp;!</h2>
                    <div className="section-para text-center no-br"><Trans>Enable employees to attain a comprehensive understanding of their well-being by integrating <br/>nutrition data with their other wellness activities.</Trans></div>
                </div>
            </section>
            <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                    <div className="col-12">
                        <h2 className="font-weight-semibold section-heading text-center no-br">
                        <Trans>Accessible Nutrition for Your Team</Trans>
                        </h2>
                        <p className="sub-para font-weight-normal text-center mb-5 text-white">
                        <Trans>Ready to achieve a harmonious balance of diet and hydration? Let's begin.</Trans>
                        </p>
                        <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                            <a href={t(`/request-demo/`)} className="vfitcompanycta arrowbtn-img">
                                <Trans>Book a Demo</Trans>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default NutritionHydration;
